export default __webpack_public_path__ + "static/media/PRXLogo.847f3253.png";